import * as React from 'react';

import _ from 'lodash';
import { compose } from 'recompose';
import connectToStores from 'vendor/cnpm/fluxible.v0-4/addons/connectToStores';

import type { ActionContext } from 'js/lib/ActionContext';

import type { NotificationType } from '@coursera/coursera-ui';
import { Notification as NotificationBase } from '@coursera/coursera-ui';

import 'css!./__styles__/StaffManagementNotification';

import type { NotificationData } from './store';
import { actions } from './store';
import withFluxibleContextAsProps from './withFluxibleContextAsProps';

type Props = {
  isDismissible?: boolean;
  isTransient?: boolean;
  message?: string;
  onDismiss?: () => void;
  transientDuration?: number;
  type?: NotificationType;
};

export const StaffManagementNotification = ({
  isDismissible = true,
  isTransient = true,
  message = '',
  onDismiss = _.noop,
  transientDuration = 5000,
  type = 'info' as const,
}: Props) => {
  return message ? (
    <div className="rc-StaffManagementNotification" data-e2e={StaffManagementNotification.e2eName}>
      <NotificationBase
        message={message}
        isDismissible={isDismissible}
        isTransient={isTransient}
        onDismiss={onDismiss}
        // Notification is styled internally with inline styles and needs same specificity overrides.
        style={{ width: 'auto' }}
        transientDuration={transientDuration}
        type={type}
      />
    </div>
  ) : null;
};

StaffManagementNotification.e2eName = 'staff-management-notification';

export const storeConnector = ({ StaffManagementStoreV2 }: $TSFixMe, { executeAction, ...rest }: $TSFixMe) => {
  // It seems that the state of the notification does not get overwritten unless it
  // is explicitly overwritten when managed by connectToStores... so we explicitly
  // overwrite things.
  const notification: NotificationData | undefined = _.first(StaffManagementStoreV2.notifications()) || {
    message: '',
  };
  return {
    onDismiss: () => {
      return executeAction(actions.notifications.dequeue);
    },
    ...notification,
    ...rest,
  };
};

export default compose<Props, Props>(
  withFluxibleContextAsProps(),
  connectToStores<Props, Props & ActionContext>(['StaffManagementStoreV2'], storeConnector)
)(StaffManagementNotification);
